import { combineReducers } from 'redux';

// import gameDetailsReducer from './reducers/gameDetailsReducer';
import gameProgressReducer from './reducers/gameProgressReducer';
import roundPlayReducer from './reducers/roundPlayReducer';
import screenReducer from './reducers/screenReducer';
import gameDetailsReducer from './reducers/gameDetailsReducer';

const reducers = combineReducers({
  gameProgress: gameProgressReducer,
  roundPlay: roundPlayReducer,
  screen: screenReducer,
  gameDetails: gameDetailsReducer,
});

export default reducers;
